import {Component, inject, Input, OnInit} from '@angular/core';
import {Language} from '../../../interfaces/language';
import {SharedService} from '../../services/shared.service';
import {Router} from '@angular/router';
import {Information} from '../../../interfaces/spot.interface';
import {IonButton, IonCol, IonContent, IonIcon, IonModal, IonRow} from '@ionic/angular/standalone';
import {NgIf, NgTemplateOutlet} from '@angular/common';
import {ModalConfig} from '../../../interfaces/modal';
import {SpotInformationComponent} from '../spot-information/spot-information.component';
import {SpotUtilService} from '../../services/spot-util.service';

@Component({
    selector: 'app-spot-detail-modal',
    templateUrl: './spot-detail-modal.component.html',
    styleUrls: ['./spot-detail-modal.component.scss'],
    imports: [
        IonContent,
        IonButton,
        IonIcon,
        IonRow,
        NgTemplateOutlet,
        NgIf,
        IonCol,
        IonModal,
        SpotInformationComponent
    ]
})
export class SpotDetailModalComponent implements OnInit {
    @Input() spot!: Information | any;
    @Input() modalConfig!: ModalConfig;
    isFavoriteButtonEnable = true;
    useLang: Language = 'ja';

    sharedService = inject(SharedService);
    router = inject(Router);
    spotUtilService = inject(SpotUtilService);

    constructor() {
    }

    ngOnInit() {
        console.log(this.spot);
    }

    public stateMapDetail(): void {
        const locationUrl =
            this.useLang === 'ja' || !this.hasTargetLangLocationUrl
                ? this.spot?.locationUrl
                : this.spot?.translation[this.useLang]?.locationUrl;
        if (!locationUrl) {
            return;
        }
        if (!window.open(locationUrl, '_blank')) {
            window.location.href = locationUrl;
        }
    }

    public async goLocation(): Promise<void> {
        const mapUrl = await this.spotUtilService.getGoogleMapNavi(this.spot);
        if (!mapUrl) return;
        if (!window.open(mapUrl, '_blank')) {
            window.location.href = mapUrl;
        }
    }

    /**
     * モーダルの右上のバツをクリックするとモーダルが閉じる
     */
    public closeModal(): void {
        this.modalConfig.isOpen = false;
    }

    onDidDismissModal() {
        this.modalConfig.isOpen = false;
    }

    /**
     * 対象言語のスポット名データあるか
     */
    get isDisplayJapaneseLocationName(): boolean {
        let result: boolean;
        result =
            this.useLang === 'ja' ||
            !this.useLang ||
            !this.spot.translation ||
            !this.spot.translation[this.useLang] ||
            this.spot.translation[this.useLang]?.name == null;
        return result;
    }

    /**
     * 対象言語のURLデータあるか
     */
    get hasTargetLangLocationUrl(): boolean {
        let result: boolean;
        result =
            this.useLang &&
            this.spot.translation &&
            this.spot.translation[this.useLang] &&
            this.spot.translation[this.useLang]?.locationUrl != null;
        return result;
    }
}
